import script from "./mvt-reorder.vue?vue&type=script&lang=js"
export * from "./mvt-reorder.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__